import Footer from "examples/Footer";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import React, { useState } from "react";
import {
  TextField,
  Button,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Grid,
  Box,
  Typography,
  Card,
  CardContent,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import OutlinedInput from "@mui/material/OutlinedInput";
import ProductEditForm from "./ProductEditForm";

const EditProduct = () => {
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <Box py={2}>
        <Typography variant='h5' gutterBottom>
          Edit Product
        </Typography>
        <ProductEditForm />
      </Box>
      <Footer />
    </DashboardLayout>
  );
};

export default EditProduct;
